import { useEffect, useState } from "react";

// Returns true when the viewport is below `breakpoint` (default 768px ─ Tailwind md).
// Listens to resize events with a small debounce.
export function useIsMobile(breakpoint = 768) {
  const get = () => (typeof window !== "undefined" ? window.innerWidth < breakpoint : false);
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    let t;
    const onResize = () => {
      clearTimeout(t);
      t = setTimeout(() => setIsMobile(get()), 80);
    };
    window.addEventListener("resize", onResize);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", onResize);
    };
  }, [breakpoint]);
  return isMobile;
}
